import { render, staticRenderFns } from "./QuestionView.vue?vue&type=template&id=7db8772a&scoped=true"
import script from "./QuestionView.vue?vue&type=script&lang=js"
export * from "./QuestionView.vue?vue&type=script&lang=js"
import style0 from "./QuestionView.vue?vue&type=style&index=0&id=7db8772a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db8772a",
  null
  
)

export default component.exports